import { useaxios } from "../../../utils/useaxios";
export default (item_name, item_barcode, item_price, item_unit_one, item_unit_many, item_unit_one_of_many, item_min_notification, category_id, item_id) => recaller => setrecaller => initDispatch => clear => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    initDispatch({ type: 'loadingTrue' });
    useaxios('item/update.php', { item_name, item_barcode, item_price, item_unit_one, item_unit_many, item_unit_one_of_many, item_min_notification, category_id, item_id }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            alert('no internet connection');
            initDispatch({ type: 'loadingFalse' });
            return false;
        } else if (res.status == "ok") {
            setrecaller(recaller + 1);
        }
        // setloading(false);
    });
}